import type { PillTone } from "@buildpy/ui/pill";
import type { ProjectLogKind } from "@buildpy/core/modules/project/types";

// 일지 종류 칩 색 — 메모는 조용히, 노쇼·추가공정은 견적까지 번질 수 있으니 눈에 띄게(관리 화면·고객 화면 한 벌).
export const LOG_KIND_TONE: Record<ProjectLogKind, PillTone> = {
  NOTE: "neutral",
  ISSUE: "danger",
  NO_SHOW: "hold",
  EXTRA_WORK: "progress",
  WARRANTY_AS: "primary",
};
